module.exports = __webpack_public_path__ + "assets/img/bhelp2.1d600db2.png";